import FormElementMixin from '../mixins/FormElementMixin.js';

Vue.asyncComponent('ak-address', {
    mixins: [FormElementMixin],
    data() {
        return {
            localAddress: {
                street: null,
                streetNumber: null,
                extra: null,
                city: null,
                postalCode: null,
                country: null,
                lat: null,
                lng: null,
            },
            googleApiKey: this.$getSetting('google.apiKey'),
            timer: null,
            map: null,
            markers: [],
        }
    },
    props: {
        countryOptions: {
            type: String,
            default: null,
        },
        showMap: {
            type: Number|Boolean,
            default: false
        },
        hideBusNumber: {
            type: Number|Boolean,
            default: false
        },
        zoomLevel: {
            type: String|Number,
            default: 13
        }
    },
    watch: {
        localAddress: {
            handler(newValue) {
                this.currentValue = newValue;

                // if we have an api key we can get the lat and long for the given address
                if (this.googleApiKey) {
                    clearTimeout(this.timer);
                    this.timer = setTimeout(this.getLatLng, 500);
                }
            },
            deep: true
        },
        currentValue(newValue) {
            if (newValue !== this.localAddress) {
                this.localAddress = {...this.localAddress, ...newValue};
            }
        }
    },
    computed: {
        activeCountryOptions() {
            let countries = JSON.parse(this.countryOptions);

            if (!countries) {
                return [];
            }

            return Object.keys(countries).map((key) => {
                return {
                    value: key,
                    label: countries[key],
                }
            });
        }
    },
    methods: {
        addGoogleMapsScript() {
            const script = document.createElement("script");
            script.type = "text/javascript";
            script.src = "https://maps.googleapis.com/maps/api/js?key=" + this.googleApiKey;
            document.body.appendChild(script);

            script.onload = this.renderMap;
        },
        async renderMap() {
            const { Map, InfoWindow } = await google.maps.importLibrary("maps");

            const myLatLng = {
                lat: this.localAddress.lat ? parseFloat(this.localAddress.lat): 50.5039,
                lng: this.localAddress.lng ? parseFloat(this.localAddress.lng) : 4.4699
            };

            this.map = new Map(document.querySelector(".ak-form__address-map"), {
                     zoom: 7,
                     center: myLatLng,
                     disableDefaultUI: true,
                     zoomControl: true,
                     scrollwheel: false,
                     mapId: 'blueprint-cms-map'
            });


            if(this.localAddress.lat && this.localAddress.lng) {
                this.renderMarker();
            }

            this.map.addListener('click', this.clickMapPosition)
        },
        clearMarkers() {
            this.markers.forEach(marker => {
                marker.setMap(null);
            })

            this.markers = [];
        },
        async renderMarker() {
            const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

            this.clearMarkers();

            const map = this.map

            const marker = new AdvancedMarkerElement({
                position: {lat: parseFloat(this.localAddress.lat), lng:  parseFloat(this.localAddress.lng)},
                map,
                gmpDraggable: true,
            });

            this.map.setZoom(parseInt(this.zoomLevel));

            this.map.setCenter( {lat: this.localAddress.lat, lng: this.localAddress.lng});

            this.markers.push(marker);

            marker.addListener("dragend", (e) => {
                const position = marker.position;

                this.localAddress.lat = position.lat;
                this.localAddress.lng = position.lng;

                // this.map.setZoom(11);
                this.map.setCenter({lat: this.localAddress.lat, lng: this.localAddress.lng});
                this.markers.push(marker);
            });

        },
        /**
         * We da an api key to google to get the Lat and Long for the current address
         * @returns {Promise<void>}
         */
        async getLatLng() {
            const params = {
                address: this.getAddressFull(),
            };
            const geocoder = new google.maps.Geocoder();

            const result = await geocoder.geocode(params);

            if (result.results.length) {
                this.localAddress.lat = result.results[0].geometry.location.lat();
                this.localAddress.lng = result.results[0].geometry.location.lng();

                // show a marker on the position
                this.renderMarker();
            }
        },
        getAddressFull() {
            return `${this.localAddress.street} ${this.localAddress.streetNumber} ${this.localAddress.extra} ${this.localAddress.postalCode} ${this.localAddress.city} ${this.localAddress.country}`;
        },
        clickMapPosition(mapsMouseEvent) {
            this.clearMarkers();
            const map = this.map
            const marker = new google.maps.Marker({
                position: mapsMouseEvent.latLng,
                map
            });

            this.localAddress.lat = mapsMouseEvent.latLng.toJSON().lat;
            this.localAddress.lng = mapsMouseEvent.latLng.toJSON().lng;

            this.map.setZoom(parseInt(this.zoomLevel));
            this.map.setCenter({lat: this.localAddress.lat, lng: this.localAddress.lng});
            this.markers.push(marker);
        }
    },
    created() {
        if (this.value) {
            this.localAddress = {...this.localAddress, ...this.value};
        }

        if (this.showMap) {
            if (window.google == undefined) {
                this.addGoogleMapsScript();
            } else {
                this.$nextTick(this.renderMap);
                this.renderMarker();
            }
        }
    }
}, 'form/controls/ak-address.html');
